<div class="container-card">
    <p class="title">{{ 'deleteAccount.title' | translate }}</p>
    <p class="description">{{ 'deleteAccount.description' | translate }}</p>

    <!-- Form -->
    <form [formGroup]="form">
        <mat-form-field class="example-full-width">
            <mat-label>{{ 'deleteAccount.emailLabel' | translate }}</mat-label>
            <input matInput [placeholder]="'deleteAccount.emailPlaceholder' | translate" formControlName="email">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>{{ 'deleteAccount.passwordLabel' | translate }}</mat-label>
            <input type="password" matInput [placeholder]="'deleteAccount.passwordPlaceholder' | translate" formControlName="password">
        </mat-form-field>
    </form>

    <!-- Button send -->
    <button (click)="removeAccount()">
        @if (!loading)
        {
            <span>{{ 'deleteAccount.remove' | translate }}</span>
        }
        @else
        {
            <ra-loading />
        }
    </button>
</div>
